import React from 'react'

// @material-ui/core components
import Grid from '@material-ui/core/Grid'

// core components
import withSection from 'components/withSection'
import TwoColumns from 'layouts/TwoColumns'
import List from 'components/List/List'

const Skills = ({ title, subtitle, items }) => {
  return (
    <TwoColumns
      icon={['fab', 'github']}
      list={
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <List title={title} subtitle={subtitle} />
          </Grid>
          {items.map(domain => (
            <Grid item sm={6} key={domain.id}>
              <List
                title={domain.title}
                subtitle={domain.subtitle}
                items={domain.list}
              />
            </Grid>
          ))}
        </Grid>
      }
    />
  )
}

export default withSection({ id: 'skills' })(Skills)
